module.exports = __webpack_public_path__ + "static/img/tt.cd3e7c0c.svg";